module.exports = __webpack_public_path__ + "static/img/reference pics_redmud tainan.28790d22.jpg";